// App.js
import React, {useState, useEffect} from 'react';
import './index.css';
import Home from './component/Home/home';
import Preloader from './component/Home/modal/webPreloader';

function App() {
  const [loading, setLoading] = useState(true);
  const [showWelcome, setShowWelcome] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {

    const visitedBefore = localStorage.getItem('visited');
    const lastSection = localStorage.getItem('lastSection');

    

    const loaderTimer = setTimeout(() => {
      setShowLoader(false);
      const welcomeTimer = setTimeout(() => {
        setShowWelcome(true);
        const contentTimer = setTimeout(() => {
          setLoading(false);
        }, 3000); // The content will appear 3 seconds after the welcome message

        return () => clearTimeout(contentTimer);
      }, 3000); // The welcome message will appear 3 seconds after the loading dots disappear

      return () => clearTimeout(welcomeTimer);
    }, 3000); // The loading dots will disappear after 3 seconds

    return () => clearTimeout(loaderTimer);

  }, []);

  return (
    <div className='App'>
      {loading ? <Preloader showWelcome={showWelcome} showLoader={showLoader} /> : <Home />}
    </div>
  );
}

export default App;

